<template>
  <div>
    <div class="total" v-if="sources.length > 0">
      {{ (currentSource + 1) }} / {{ sources.length }}
    </div>

    <div class="view">
      <div class="buttons" v-if="lists.length > 0">
        <div>
          <ul>
            <li
              v-for="(folder, key) in lists" :key="key"
              class="button" :class="{'selected': (currentList === folder)}" 
              @click="getMediaSources(folder)"
            >
              {{ folder }}
            </li>
          </ul>
        </div>
      </div>

      <div class="media" v-if="(lists.length > 0 && sources.length > 0)">
        <img class="file" v-if="media_path && media_type === 'img'" :src="'./media/fotos/'+ mediaFilePath" />
        <video class="file" controls v-if="media_path && media_type === 'video'" :src="'./media/videos/'+ mediaFilePath"></video>

        <button class="arrow" :disabled="currentSource === 0" @click="previousMedia()"><img src="../assets/back.svg" /></button>
        <button class="arrow next" :disabled="currentSource === (sources.length - 1)" @click="nextMedia()"><img src="../assets/next.svg" /></button>
      </div>

      <div class="no-content" v-else>
        <h4>Sem conteúdo</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    media_type: {
      type: String,
      default: 'img'
    },
    media_path: {
      type: String,
      default: null
    }
  },
  data: () => ({
    lists: [],
    sources: [],
    currentList: null,
    currentSource: 0,
  }),
  computed: {
    mediaFilePath() {
      return this.media_path + '/' + this.sources[this.currentSource];
    }
  },
  methods: {
    async getMediaLists() {
      const response = await this.$api.mediaList(this.media_type, String(this.media_path).split('/').join('_'));
      this.lists = response.data;
      if (this.lists[0]) {
        this.getMediaSources(this.lists[0]);
      }
    },
    async getMediaSources(folder) {
      this.currentList = folder;
      const response = await this.$api.mediaList(this.media_type, this.media_path + '_' + folder);

      let sources = response.data || [];
      sources = sources.map((source) => folder + '/' + source)

      this.currentSource = 0;
      this.sources = sources;
    },
    previousMedia() {
      this.currentSource--;
    },
    nextMedia() {
      this.currentSource++;
    }
  },
  created() {
    this.getMediaLists()
  }
};
</script>

<style lang="scss" scoped>
.total {
  text-align: center;
  padding: 2px 0;
}

.view {
  display: flex;

  .buttons {
    width: 25%;
    margin-right: 2px;

    .button {
      background: #F8CBAD;
      text-align: center;
      border: 1px solid var(--color-grey);
      padding: 10px 5px;
      margin-bottom: 1px;
      cursor: pointer;

      &.selected {
        background: #F7B990;
      }
    }

    ul {
      -moz-column-count: 2;
      -webkit-column-count: 2;
      column-count: 2;
      -webkit-column-gap: 0.25rem;
      -moz-column-gap: 0.25rem;
      column-gap: 0.25rem;
    }

    li {
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid-column;
      list-style: none;
    }
  }
  
  .media {
    position: relative;
    overflow: hidden;
    flex: 1;

    .file {
      width: 100%;
    }

    .arrow {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 50%;
      height: 70px;
      width: 70px;
      left: calc(0% - 70px);
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.5);
      padding: 17px;
      outline: black;
      transition: right 200ms, left 200ms, background 200ms linear;
      cursor: pointer;
      
      img {
        height: 30px;
        margin-right: 4px;
      }

      &.next {
        left: 100%;

        img {
          margin-right: 0;
          margin-left: 4px;
        }
      }

      &:hover {
        background: rgba(0, 0, 0, 0.7);
      }

      &:disabled {
        background: transparent;
        color: #f1f1f1;
        border: 1px solid transparent;

        img {
          height: 0px;
        }
      }
    }

    &:hover > .arrow {
      left: 0%;
    }

    &:hover > .arrow.next {
      left: calc(100% - 70px);
    }
  }

  .no-content {
    flex: 1;
    text-align: center;
  }
}


@media (max-width: 900px) {
  .view {
    .buttons {
      ul {
        -moz-column-count: 1;
        -webkit-column-count: 1;
        column-count: 1;
      }
    }

    .media {
      .arrow {
        top: 32%;
        height: 35px;
        width: 35px;
        left: calc(0% - 35px);
        
        img {
          height: 15px;
          margin-right: 2px;
        }

        &.next {
          img {
            margin-right: 0;
            margin-left: 2px;
          }
        }
      }

      &:hover > .arrow.next {
        left: calc(100% - 36px);
      }
    }
  }
}
</style>
